var nonScopeMethods = ['init', 'defineWatches', '$inject'];

export default {
    create: function create($scope) {
        this.defineWatches();
        this.init();
        for (var prop in this) {
            if (this.hasOwnProperty(prop) && prop.charAt(0) !== '_' && typeof this[prop] === 'function' && nonScopeMethods.indexOf(prop) === -1) {
                $scope[prop] = this[prop];
            }
        }
        return this;
    },


    defineWatches: function defineWatches() {
        // OVERRIDE : put all watches and event listeners here
    },

    init: function init() {
        // OVERRIDE : Initialise the scope with service populated data when controller is instantiated
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/base/BaseCtrl.js
// module id = 6
// module chunks = 0